export enum PaginatedStoreIdsEnum {
  CONTENT_DESIGN_LIBRARY = "contentDesignLibrary",
  CREATE_PREDESIGNED_ACTIVITY = "createPredesignedActivity",
  MANAGE_ACTIVITIES = "manageActivities",
  MANAGE_LIVE_CLASSES = "manageLiveClasses",
  MANAGE_AFFILIATIONS = "manageAffiliations",
  MANAGE_PRELOADED_CONTENT = "managePreloadedContent",
  MANAGE_QR_CODES = "manageQrCodes",
  MANAGE_USERS = "manageUsers",
  STUDENT_MARKSHEET_REPORT = "studentMarksheetReport",
  TUTORING_ADMIN_DEMO_SESSIONS = "tutoringAdminDemoSessions",
  TUTORING_ADMIN_PAID_SESSIONS = "tutoringAdminPaidSessions",
  TUTORING_STUDENT_DASHBOARD = "tutoringStudentDashboard",
  TUTORING_TUTOR_DASHBOARD = "tutoringTutorDashboard",
  TUTOR_SESSION_REPORTS = "tutorSessionReports",
  // Demo-only — backs the PaginatedCards section in WidgetsShowcase (UI Kit).
  WIDGETS_SHOWCASE = "widgetsShowcasePaginated",
}

export enum FilterableStoreIdsEnum {
  CONTENT_COURSE_LIBRARY = "contentCourseLibrary",
  MANAGE_BATCHES = "manageBatches",
  MANAGE_OFFLINE_ACTIVITIES = "manageOfflineActivities",
  MANAGE_PAST_YEAR_PAPERS = "managePastYearPapers",
  MANAGE_PRELOADED_CONTENT = "managePreloadedContent",
  MANAGE_QUESTION_PDFS = "manageQuestionPdfs",
  MANAGE_PREDESIGNED_ACTIVITIES = "managePredesignedActivities",
  MANAGE_TUTORING_DEMO_STUDENTS = "manageTutoringDemoStudents",
  MANAGE_TUTORING_PAID_STUDENTS = "manageTutoringPaidStudents",
  SEARCH_USERS_BY_TEXT = "searchUsersByText",
  TUTORING_MONTHLY_REPORT = "tutoringMonthlyReport",
  TUTORING_STUDENT_STUDY_NOTES = "tutoringStudentStudyNotes",
  TUTORING_TUTOR_LESSON_PLANS = "tutoringTutorLessonPlans",
  TUTOR_UNASSIGNED_DEMOS = "tutorUnassignedDemos",
  MANAGE_TUTORING_TUTORS = "manageTutoringTutors",
  // Demo-only — backs the FilterableCards section in WidgetsShowcase (UI Kit).
  WIDGETS_SHOWCASE = "widgetsShowcaseFilterable",
  // Demo-only — backs the FilterableCardsPanel section in WidgetsShowcase (UI Kit).
  WIDGETS_SHOWCASE_PANEL = "widgetsShowcaseFilterablePanel",
}

export enum ManageBatchesSortingOptionsEnum {
  BATCH = "Batch",
  EXPIRY_DATE = "ExpiryDate",
  TOTAL_STUDENTS = "TotalStudents",
  CLASS = "Class",
  ACADEMIC_SESSION = "AcademicSession",
}

export enum ManagePredesignedActivitiesSortingOptionsEnum {
  IS_FINALIZED = "IsFinalized",
  TOTAL_QUESTIONS = "TotalQuestions",
  DURATION = "Duration",
  MAXIMUM_MARKS = "MaximumMarks",
}

export enum ManagePastYearPaperSortingOptionsEnum {
  QUESTION_PAPER_NAME = "QuestionPaperName",
  ACADEMIC_SESSION = "AcademicSession",
  CONDUCTED_ON = "ConductedOn",
}

export enum ManageQuestionPdfSortingOptionsEnum {
  CREATED_ON = "CreatedOn",
  CREATED_BY = "CreatedBy",
  TOTAL_QUESTIONS = "TotalQuestions",
}
